import { useEffect, useRef, useState } from 'react';

import { Badge, BadgeVariants } from '../../../ui/Badge';

type PercentageChangeBadgeProps = {
  percentageChange: number;
  variant: BadgeVariants;
};

export function PercentageChangeBadge({ percentageChange, variant }: PercentageChangeBadgeProps) {
  const formatterRef = useRef(
    Intl.NumberFormat('en-US', {
      style: 'percent',
      maximumFractionDigits: 1,
      signDisplay: 'always', // always show the sign
    }),
  );

  const percentage = formatterRef.current.format(percentageChange);
  const [ariaLabel, setAriaLabel] = useState(
    `The difference between limit price and market price is ${percentage}`,
  );

  useEffect(() => {
    // This is a workaround for the badge not being read out by screen readers
    // when the value of the limit order input field gets updated.
    const timeout = setTimeout(() => {
      setAriaLabel(`The difference between limit price and market price is ${percentage}`);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [percentage]);

  // The multiplication by 10 and division by 10 is to round to the nearest tenth
  const showBadge = Math.round(percentageChange * 100 * 10) / 10 !== 0;

  return (
    <Badge
      variant={variant}
      aria-label={showBadge ? ariaLabel : undefined}
      aria-hidden={!showBadge}
      data-hide-badge={!showBadge}
    >
      <span aria-hidden>{percentage}</span>
    </Badge>
  );
}
